import { useState, useEffect } from 'react';
import { onSnapshot, } from 'firebase/firestore';
import { useToggle, } from 'react-use';

export default function useCollectionSubscription (ref, dependencies = [], { initialItems = [], refreshDisabled = false, detail = false, } = {}) {
  const [items, setItems] = useState(initialItems);
  const [isLoading, toggleLoading] = useToggle(false);
  useEffect(() => {
    if(!refreshDisabled) setItems([]);
    if(!ref) return;

    toggleLoading(true);
    const unsubscribe = onSnapshot(ref, ({ docs }) => {
      setItems(docs.map(_ => ({ ..._.data(), id: _.id, ref: _.ref, })));
      toggleLoading(false);
    }, e => console.error(ref, e));
    return unsubscribe;
  }, dependencies);
  return detail ? { items, isLoading } : items;
};
